var React = require('react');

function MinusCircle (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z","stroke":"currentColor","strokeWidth":"2","strokeMiterlimit":"10","key":0}),React.createElement("path",{"d":"M8.25 12H15.75","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

MinusCircle.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 24 24","fill":"none"};

module.exports = MinusCircle;

MinusCircle.default = MinusCircle;
